import { createContext, useState } from 'react';

export interface IAuth {
  email: string;
  password: string;
  accessToken: string;
  role: string;
}

export type AuthType = {
  auth: IAuth;
  setAuth: (s: React.SetStateAction<IAuth>) => void;
  registrationDisabled: boolean;
  setRegistrationDisabled: (s: React.SetStateAction<boolean>) => void;
};

// added this
export const EMPTY_AUTH: IAuth = {
  email: '',
  password: '',
  accessToken: '',
  role: '',
};

// export const AuthContext = createContext({});
export const AuthContext = createContext<AuthType | null>(null);


export const AuthProvider = ({ children }: React.PropsWithChildren) => {
  // const [auth, setAuth] = useState({});
  // changed this
  const [auth, setAuth] = useState<IAuth>(EMPTY_AUTH);
  const [registrationDisabled, setRegistrationDisabled] = useState<boolean>(false);
  return (
    <AuthContext.Provider value={{ auth, setAuth, registrationDisabled, setRegistrationDisabled }}>
      {children}
    </AuthContext.Provider>
  );
};
